// Keyboard-shortcut registry for the blob page. This is the single source of
// truth for the "?" help popup. It documents the shortcuts that are actually
// wired up in the handlers (Blob page + workflow editor/playground/widgets);
// keep the two in sync when adding or changing a binding.
//
// A section is shown when its `types` is "*" (every blob) or includes the
// current blob's "<domain>:<type>" key (e.g. "workflow:generic"). Each shortcut
// is one chord: an array of key tokens rendered joined by "+".

export const MOD = "Mod"; // rendered as ⌘ on macOS, Ctrl elsewhere

export function isMac() {
  if (typeof navigator === "undefined") return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || "");
}

// A group is one column in the popup. It has a title and one or more sections;
// a section may carry its own sub-title (rendered as a sub-heading beneath the
// group title). A group is shown when `types` is "*" or includes the blob key.
export const SHORTCUT_GROUPS = [
  {
    title: "Global",
    types: "*",
    sections: [
      {
        shortcuts: [
          { keys: [MOD, "E"], label: "Expand / collapse header" },
          { keys: ["?"], label: "Show keyboard shortcuts" },
        ],
      },
    ],
  },
  {
    title: "Workflow Blob",
    types: ["workflow:generic"],
    sections: [
      {
        title: "Workflow Editor",
        shortcuts: [
          { keys: [MOD, "S"], label: "Save workflow", note: "when modified" },
          { keys: [MOD, "R"], label: "Refresh workflows", note: "when unchanged" },
        ],
      },
      {
        title: "Playground",
        shortcuts: [
          { keys: [MOD, "S"], label: "Save playground", note: "when modified" },
          { keys: [MOD, "R"], label: "Refresh sessions", note: "when unchanged" },
        ],
      },
    ],
  },
];

// Groups applicable to a blob, given its "<domain>:<type>" key.
export function groupsForBlobType(typeKey) {
  return SHORTCUT_GROUPS.filter(
    (group) => group.types === "*" || (typeKey && group.types.includes(typeKey))
  );
}

// Display label for a single key token.
export function keyLabel(token) {
  if (token === MOD) return isMac() ? "⌘" : "Ctrl";
  return token;
}
